import { useToast } from "@/hooks/use-toast";

export function useToastApi() {
  const { toast } = useToast();

  return {
    ok: (title: string, description?: string) =>
      toast({ title, description, variant: "default" }),
    fail: (err: any, fallback = "Unexpected error") => {
      const msg = typeof err === "string" ? err : err?.message || fallback;
      toast({ title: "Action failed", description: msg, variant: "destructive" });
    },
    info: (title: string, description?: string) => 
      toast({ title, description, variant: "default" }),
    warn: (title: string, description?: string) => 
      toast({ title, description, variant: "destructive" }),
    success: (title: string, description?: string) => 
      toast({ title, description, variant: "default" }),
    error: (title: string, description?: string) => 
      toast({ title, description, variant: "destructive" }),
    // Specific helpers for common scenarios
    saved: (item = "Changes") => toast({ title: `${item} saved!`, description: "Your updates have been applied" }),
    deleted: (item = "Item") => toast({ title: `${item} deleted`, description: "The item has been removed" }),
    uploaded: (item = "File") => toast({ title: `${item} uploaded!`, description: "Your file is now available" }),
    reauth: () => toast({ title: "Authentication needed", description: "Please re-link your account to continue", variant: "destructive" }),
    processing: (action = "Processing") => toast({ title: `${action}...`, description: "This may take a moment" }),
  };
}
